import { SDLUtil, RequestUtil, StringUtil } from '@/utils';
const setAccountTrendList = ({commit}, data) => {
  commit('SET_ACCOUNT_TREND_LIST', data);
};

const setAccountDiffList = ({commit}, data) => {
  commit('SET_ACCOUNT_DIFF_LIST', data);
};

const setAccountStatusList = ({commit}, data) => {
  commit('SET_ACCOUNT_STATUS_LIST', data);
};

const setAccountScpStatusList = ({commit}, data) => {
  commit('SET_ACCOUNT_CSP_STATUS_LIST', data);
};
export default {
  async GET_ACCOUNT_TREND_LIST(store, params) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/cloudaccount/division-trend?${StringUtil.queryStringfy(params)}`)
    setAccountTrendList(store, data.data);
  },
  async GET_ACCOUNT_DIFF_LIST(store, params) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/cloudaccount/division-diff?${StringUtil.queryStringfy(params)}`)
    setAccountDiffList(store, data.data);
  },
  async GET_ACCOUNT_STATUS_LIST(store, params) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/cloudaccount/division-status?${StringUtil.queryStringfy(params)}`)
    setAccountStatusList(store, data.data);
  },
  async GET_ACCOUNT_CSP_STATUS_LIST(store, params) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/monitoring/cloudaccount/division-csp-status?${StringUtil.queryStringfy(params)}`)
    setAccountScpStatusList(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/summary/accountDivisionAction.js